var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoldova(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_33180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2175 1.19072C15.6399 0.427875 13.87 0 12.0001 0C10.1303 0 8.36037 0.427875 6.78274 1.19072L5.73926 12L6.78274 22.8093C8.36037 23.5721 10.1303 24 12.0001 24C13.87 24 15.6399 23.5721 17.2175 22.8093L18.261 12L17.2175 1.19072Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.78263 1.19113C2.76872 3.13208 0 7.24251 0 12C0 16.7575 2.76872 20.8679 6.78263 22.8088V1.19113Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2178 1.19113V22.8088C21.2317 20.8679 24.0004 16.7575 24.0004 12C24.0004 7.24251 21.2317 3.13208 17.2178 1.19113Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.174 9.44152H13.3044C13.3044 8.72115 12.7204 8.13718 12.0001 8.13718C11.2797 8.13718 10.6957 8.72115 10.6957 9.44152H7.82617C7.82617 10.1508 8.44403 10.7257 9.1532 10.7257H9.11045C9.11045 11.435 9.68542 12.01 10.3947 12.01C10.3947 12.638 10.8458 13.1598 11.4415 13.2714L10.4294 15.5562C10.9143 15.7533 11.4443 15.8628 12.0001 15.8628C12.5558 15.8628 13.0858 15.7533 13.5707 15.5562L12.5587 13.2714C13.1544 13.1598 13.6054 12.638 13.6054 12.01C14.3147 12.01 14.8897 11.435 14.8897 10.7257H14.8469C15.5561 10.7257 16.174 10.1507 16.174 9.44152Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 11.2173L10.3047 12V13.5652L12.0003 14.6087L13.696 13.5652V12L12.0003 11.2173Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3047 10.4348H13.696V12H10.3047V10.4348Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_33180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/0f78e817.svg";
export { SvgMoldova as ReactComponent };